const productionApi = "https://panel.payacom.com/api/visitor";
const localApi = "http://localhost/DEV/public/api/visitor";

export const baseUrl =
  process.env.REACT_APP_VISITOR_API_URL ||
  (process.env.NODE_ENV === "development" ? localApi : productionApi);
